import { getAddress, type Address } from "viem";

/** Chainlink aggregator addresses on Base. */
export const CAD_USD_FEED: Address = getAddress(
  "0xa840145f87572e82519d578b1f36340368a25d5d",
);
export const USDC_USD_FEED: Address = getAddress(
  "0x7e860098f58bbfc8648a4311b374b1d669a2bc6b",
);

/** Minimal aggregator ABI for `latestAnswer` + `decimals` reads. */
export const CHAINLINK_AGGREGATOR_ABI = [
  {
    type: "function",
    name: "latestAnswer",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "int256" }],
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "uint8" }],
  },
] as const;
